<section class="attention-card d-flex flex-column">
  <header class="attention-header d-flex align-items-center">
    <mat-icon class="header-icon">notifications_active</mat-icon>
    <div class="header-text d-flex flex-column min-w-0">
      <h2 class="header-title">{{ 'app.home.attention.title' | translate }}</h2>
      <span class="header-subtitle">{{ 'app.home.attention.subtitle' | translate }}</span>
    </div>

    <div class="header-tally d-flex align-items-center gap-2 ms-auto">
      @if (home.criticalCount() > 0) {
      <span class="tally" data-severity="critical"
        [matTooltip]="'app.home.attention.tally.critical' | translate">{{ home.criticalCount() }}</span>
      }
      @if (home.warningCount() > 0) {
      <span class="tally" data-severity="warning"
        [matTooltip]="'app.home.attention.tally.warning' | translate">{{ home.warningCount() }}</span>
      }
      @if (home.infoCount() > 0) {
      <span class="tally" data-severity="info"
        [matTooltip]="'app.home.attention.tally.info' | translate">{{ home.infoCount() }}</span>
      }
    </div>
  </header>

  <div class="attention-body d-flex flex-column">
    @if (isPreparing()) {
    @for (row of skeletonRows; track row) {
    <div class="signal-skeleton d-flex align-items-center" aria-hidden="true">
      <span class="skeleton-icon"></span>
      <span class="skeleton-lines d-flex flex-column flex-grow-1">
        <span class="skeleton-line"></span>
        <span class="skeleton-line short"></span>
      </span>
    </div>
    }
    } @else if (isUnavailable()) {
    <div class="attention-clear d-flex flex-column align-items-center text-center">
      <mat-icon class="clear-icon" data-state="error">error_outline</mat-icon>
      <span class="clear-title">{{ 'app.home.attention.unavailable.title' | translate }}</span>
      <span class="clear-subtitle">{{ 'app.home.attention.unavailable.subtitle' | translate }}</span>
    </div>
    } @else if (isAllClear()) {
    <div class="attention-clear d-flex flex-column align-items-center text-center">
      <mat-icon class="clear-icon">task_alt</mat-icon>
      <span class="clear-title">{{ 'app.home.attention.all_clear.title' | translate }}</span>
      <span class="clear-subtitle">
        @if (home.isFleetScanComplete()) {
        {{ 'app.home.attention.all_clear.subtitle' | translate }}
        } @else {
        {{ 'app.home.attention.all_clear.limited' | translate }}
        }
      </span>
    </div>
    } @else {
    @for (entry of visibleSignals(); track entry.key) {
    <app-home-signal-row [entry]="entry" />
    }

    @if (hiddenCount() > 0) {
    <button type="button" mat-button class="attention-toggle align-self-start" (click)="onToggle()">
      @if (isExpanded()) {
      {{ 'app.home.attention.show_less' | translate }}
      } @else {
      {{ 'app.home.attention.show_more' | translate: { count: hiddenCount() } }}
      }
    </button>
    }
    }
  </div>

  @if (home.isFleetScanPending()) {
  <button type="button" class="attention-prompt d-flex align-items-center" (click)="onScanFleet()">
    <mat-icon class="prompt-icon">radar</mat-icon>
    <span class="prompt-text">{{ 'app.home.attention.fleet_prompt' | translate }}</span>
    <span class="prompt-action ms-auto">{{ 'app.home.fleet.scan' | translate }}</span>
  </button>
  } @else if (home.isFleetScanning()) {
  <div class="attention-scanning d-flex align-items-center">
    <mat-progress-spinner mode="indeterminate" diameter="16" />
    <span>{{ 'app.home.attention.scanning' | translate }}</span>
  </div>
  }
</section>
